module.exports = __webpack_public_path__ + "img/empty_friends.be874c1d.jpg";